import { useState } from "react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError("");

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get("website_alt")?.toString().trim();
    if (honeypot) {
      setStatus("success");
      setEmail("");
      setSubmitting(false);
      setTimeout(() => setStatus("idle"), 3000);
      return;
    }

    formData.delete("website_alt");

    try {
      const response = await fetch(
        "https://readdy.ai/api/form/d9pkcq5i2vhsdh2d368g",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(
            Object.fromEntries(formData.entries()) as Record<string, string>
          ).toString(),
        }
      );

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormError(serverMsg || "订阅失败，请稍后重试");
        setStatus("error");
      }
    } catch {
      setFormError("网络错误，请检查连接后重试");
      setStatus("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-primary-500">
      <div className="w-full max-w-[600px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅精选推送
        </h2>
        <p className="text-background-50/80 text-sm mb-8 leading-relaxed">
          每周精选优质内容，直接送达您的邮箱，不错过任何精彩
        </p>
        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-[450px] mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full text-sm bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="website-alt-field"
          />
          <button
            type="submit"
            disabled={submitting}
            className="px-7 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            <i className="ri-mail-send-line mr-1.5"></i>
            {submitting ? "提交中..." : "立即订阅"}
          </button>
        </form>
        {status === "success" && (
          <p className="mt-4 text-sm text-background-50/90">感谢订阅！我们会定期为您推送精选内容。</p>
        )}
        {status === "error" && formError && (
          <p className="mt-4 text-sm text-background-50/90">{formError}</p>
        )}
      </div>
    </section>
  );
}